import React from 'react';
import styled from 'styled-components';
import { DatePicker } from 'antd';
import { theme } from 'utils/style/theme';

/**
 *
 * @param {*} param0
 * @returns {데이트 피커}
 */
const DefaultDatePicker = ({
  title,
  bottom,
  showTime,
  onChange,
  onOk,
  minuteStep,
  showNow,
  format,
  value,
  bordered,
  style,
}) => {
  return (
    <Container style={style} title={title} bottom={bottom}>
      <label>{title}</label>
      <StyledDatePicker
        style={style}
        bordered={bordered}
        showTime={showTime}
        onChange={onChange}
        onOk={onOk}
        minuteStep={minuteStep}
        showNow={showNow}
        format={format}
        value={value}
      />
    </Container>
  );
};

export default DefaultDatePicker;

const Container = styled.div`
  margin-bottom: ${(props) => (props.bottom ? '0' : '1.2rem')};
  width: 100%;
  label {
    display: ${(props) => (props.title ? 'block' : 'none')};
    color: ${theme.colors.blue_7};
    font-size: ${theme.fontSizes.md};
    margin-left: 0.5rem;
  }
`;

const StyledDatePicker = styled(DatePicker)`
  background-color: #fff;
  margin-right: 1rem;
  width: 100%;
`;
